import { useQuery } from '@tanstack/react-query';
import { recipeViewRequests, type PopularQueryParams } from '@/lib/api/requests/recipe-views';
import { recipeViewKeys } from './keys';

export function usePopularRecipes(params?: PopularQueryParams, enabled = true) {
  return useQuery({
    queryKey: recipeViewKeys.popular(params),
    queryFn: () => recipeViewRequests.popular(params),
    enabled,
    placeholderData: (prev) => prev,
  });
}
